import { EMPLOYEE_UPDATE_REQUEST_STATUS } from "global/constants";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import colors from "theme/colors";
import { showCustomToast, showErrorToast } from "utils/utilities";

const useEmployeeDetails = () => {
  const { t } = useTranslation("common");
  const [groupPayDates, setGroupPayDates] = useState({});

  const handleGroupPayDates = ({
    getGroupsPayDatesIsSuccess = false,
    groupsPayDatesData = {},
  }) => {
    if (getGroupsPayDatesIsSuccess) {
      const { groupPayDates: groupedPayDates = [], unlinkedPayDates = [] } =
        groupsPayDatesData || {};

      if (groupedPayDates.length > 0 && unlinkedPayDates.length > 0) {
        const noGroupObj = {
          groupName: t("employeeCreation.single.noGroup"),
          payDates: unlinkedPayDates,
        };
        const newGroupPayDates = {
          groupPayDates: [...groupedPayDates, noGroupObj],
          unlinkedPayDates,
        };
        setGroupPayDates(newGroupPayDates);
      } else {
        setGroupPayDates(groupsPayDatesData);
      }
    }
  };

  const handleBanksListError = ({
    banksListIsError = false,
    banksListError = "",
    toast,
    navigate,
    resetLoginData,
  }) => {
    if (banksListIsError) {
      showErrorToast({
        error: banksListError,
        toast,
        navigate,
        resetLoginData,
      });
    }
  };

  const showCreateUpdateSuccessToast = ({
    createEmployeeResponse = {},
    singleEmployeeUpdateResponse = {},
    navigate,
    toast,
    isCreate = false,
  }) => {
    let title = "";
    let status = "";
    let style = {};
    const { status: createStatus = "" } = createEmployeeResponse;
    const { status: updateStatus = "" } = singleEmployeeUpdateResponse;
    const statusResp = isCreate ? createStatus : updateStatus;
    switch (statusResp) {
      case EMPLOYEE_UPDATE_REQUEST_STATUS.COMPLETED:
        title = isCreate
          ? "employeeCreation.single.success"
          : "employeeUpdation.single.update";
        status = "success";
        style = {
          backgroundColor: colors.success.polarGreen1,
          borderColor: colors.success.polarGreen3,
          borderWidth: 1,
        };
        break;
      case EMPLOYEE_UPDATE_REQUEST_STATUS.REJECTED:
      case EMPLOYEE_UPDATE_REQUEST_STATUS.FAILED:
        title = isCreate
          ? "employeeUpdation.single.error"
          : "employeeUpdation.single.rejected";
        status = "error";
        style = {
          backgroundColor: colors.error.dustRed,
          borderColor: colors.error.rose,
          borderWidth: 1,
        };
        break;
      case EMPLOYEE_UPDATE_REQUEST_STATUS.PENDING:
      case EMPLOYEE_UPDATE_REQUEST_STATUS.PROCESSING:
        title = isCreate
          ? "employeeUpdation.single.pending"
          : "employeeUpdation.single.processing";
        status = "warning";
        style = {
          backgroundColor: colors.warning.gold,
          borderColor: colors.warning.sunflower,
          borderWidth: 1,
        };
        break;
      default:
        title = "employeeUpdation.single.update";
        status = "success";
    }
    showCustomToast({ title, status, style, toast });
    navigate("/");
  };

  return {
    groupPayDates,
    handleGroupPayDates,
    handleBanksListError,
    showCreateUpdateSuccessToast,
  };
};

export default useEmployeeDetails;
